import { hectaresToAcres } from 'utils/areaUtil';
import { formatToUSDateTimeWith12Hour } from 'utils/dateTimeUtils/dateFormatUtil';
import { calcDurationMinutes } from 'utils/dateTimeUtils/timeUtil';

import { Checkbox } from '@american-autonomy/ag-ui';

import SelectableGridRowWrapper from 'components/SelectableGrid/components/SelectableGridRowWrapper';
import GridText from 'components/text/GridText';
import TableLink from 'components/text/TableLink';

import usePageRoutes from 'hooks/usePageRoutes';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const SelectableFlightsGridRow = ({ flight, isSelected, onSelect, testId = TEST_ID }: Props) => {
    const { applicationDetailsPage } = usePageRoutes();

    const {
        applicationId,
        applicationType,
        droneSerialNumber,
        endTime,
        pilot,
        startTime,
        totalAreaHectares
    } = flight;

    const duration = calcDurationMinutes(startTime, endTime);
    const pilotName = [pilot?.firstName, pilot?.lastName].filter(Boolean).join(' ');
    const selectedClass = isSelected ? styles.selected : '';

    return (
        <SelectableGridRowWrapper className={selectedClass} testId={testId}>
            <Checkbox isChecked={isSelected} onChange={onSelect} />

            <TableLink
                className={styles.tableLink}
                text={pilotName}
                to={applicationDetailsPage(applicationId)}
            />

            <GridText text={droneSerialNumber} />

            <GridText text={formatToUSDateTimeWith12Hour(startTime)} />

            <GridText text={`${duration}m`} />

            <GridText text={`${hectaresToAcres(totalAreaHectares)} ac`} />

            <GridText text={applicationType} />
        </SelectableGridRowWrapper>
    );
};

export default SelectableFlightsGridRow;
